export const ENG_LOCALES = ['de', 'en', 'fr', 'pt', 'pt-br', 'ru', 'zh']
